export enum SpeechTab {
  DATASETS = 'Datasets',
  MODELS = 'Models'
}
